import { useEffect, useState, useRef } from 'react';

interface UseStickyNavProps {
  scrollThreshold?: number;
  stickyOffset?: number;
}

export const useStickyNav = ({ scrollThreshold = 10, stickyOffset = 0 }: UseStickyNavProps) => {
  const [isSticky, setIsSticky] = useState(false);
  const [showNav, setShowNav] = useState(true);
  const lastScrollY = useRef(0);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 480);
    };
    
    // Initial check
    checkScreenSize();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout; 

    const handleScroll = () => {
      const currentScrollY = window.pageYOffset;

      if (currentScrollY > stickyOffset) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      // Permettre l'animation même sur petits écrans
      // Suppression de la condition qui force showNav=true sur petits écrans
      if (Math.abs(currentScrollY - lastScrollY.current) > scrollThreshold) {
        if (currentScrollY > lastScrollY.current && currentScrollY > stickyOffset) {
          setShowNav(false); 
        } else {
          setShowNav(true);
        }

        lastScrollY.current = currentScrollY;
      }
      
      clearTimeout(timeoutId);
      if (currentScrollY === 0) {
        timeoutId = setTimeout(() => {
          setShowNav(true);
        }, 100);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timeoutId);
    };
  }, [scrollThreshold, stickyOffset, isSmallScreen]);

  return { isSticky, showNav, setShowNav };
};